import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { generalGetFunction, generalPostFunction } from "../Globals/globalFunctions";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { gameName, gameSettingsRefresh, setGameSettings } from "../Redux/gameSettingsSlice";
import { gameCollectionArray, gamePorts } from "../Globals/globalMetaData";
import { SvgIcon } from "../Components/SvgIcons";

function PayoutOptions() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const {
		register,
		formState: { errors },
		handleSubmit,
		reset,
		watch,
		setValue,
	} = useForm({
		defaultValues: {
			gameName: "spin2win",
		},
	});
	const [gameName, setGameName] = useState("");
	const gameSettings = useSelector((state) => state.gameSettings.setGameSettings);

	const handlePaymode = async (data) => {
		const payload = {
			...data,
		};
		try {
			const selectedGame = gameName;
			const port = gamePorts[selectedGame] || "3042";

			const response = await generalPostFunction("/setreleaserate", payload, port);
			if (response.message.includes("updated")) {
				toast.success("Release rate updated successfully!");
			}
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		getAllSettings();
	}, [gameName]);

	const getAllSettings = async () => {
		const selectedGame = gameName;
		const port = gamePorts[selectedGame] || "3042";

		try {
			const response = await generalGetFunction(`/getallsettings`, port);
			if (response) {
				dispatch(setGameSettings(response));
				reset({ releaserate: response.releaserate });
			}
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		if (gameSettings) {
			reset({
				releaserate: gameSettings.releaserate,
			});
		}
	}, [gameSettings]);

	return (
		<>
			<div className="overviewTableWrapper">
				<div className="overviewTableChild">
					<div className="d-flex flex-wrap">
						<div className="col-12">
							<div className="heading">
								<div className="content">
									<h4>Payout Options</h4>
									<p>Payout Options of an account - Set payout mode for bets</p>
								</div>
								<div className="buttonGroup">
									<button effect="ripple" className="panelButton gray" onClick={() => navigate(-1)}>
										<span className="text">Back</span>
										<span className="icon">
											<SvgIcon name="back" />
										</span>
									</button>
									<button type="button" className="panelButton" onClick={handleSubmit(handlePaymode)}>
										<span className="text">Save</span>
										<span className="icon">
											<SvgIcon name="save" />
										</span>
									</button>
								</div>
							</div>
						</div>
						<div className="col-12" style={{ padding: "25px 23px" }}>
							<form className="mb-0" onSubmit={handleSubmit(handlePaymode)}>
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Game Name</label>
									</div>
									<div className="col-6">
										<select className="formItem" defaultValue={"spin2win"} onChange={(e) => setGameName(e.target.value)}>
											{gameCollectionArray && gameCollectionArray.length > 0
												? gameCollectionArray.map((item, index) => {
														return <option value={item.value}>{item.label}</option>;
													})
												: ""}
										</select>
									</div>
								</div>
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Release Rate</label>
									</div>
									<div className="col-6">
										<div className="d-flex justify-content-between align-items-center w-100">
											<input type="range" step={"0.05"} min={"0.4"} max={"1"} {...register("releaserate")} className="col-9" />
											<label className="fw-bold">{(watch().releaserate * 100).toFixed(2)}%</label>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default PayoutOptions;
